import {createEntityAdapter} from '@reduxjs/toolkit'
import {IDeal} from '../../types'

export const dealsAdapter = createEntityAdapter<IDeal>()